<template lang="pug">
    div.launcher
        Dropdown(trigger="custom" :visible="visible" style="margin-left: 20px" v-click-outside="onClickOutside")
            Button.trigger.mobile(@click="visible=!visible" shape="circle" icon="ios-search" size="small")
            DropdownMenu.dropdown-menu(slot="list")
                Input.search-box.mobile(@input="handleInput" @on-focus="handleFocus" v-model="searchText" search :placeholder="searchPlaceHolder")
                Spin(size="large" fix v-if="spinShow")
                Card
                    template(v-if="noResult")
                        span {{ $t('main.selectNotFoundText') }}
                    template(v-else)
                    Row(v-for="resourceResult in results" :key="resourceResult.resourceType" v-if="resourceResult.resources.length > 0" style="margin-bottom: 15px;")
                        List.launcher-list
                            template(slot="header")
                                h3 {{ $i18n.t(`resourceType.${resourceResult.resourceType}`) }}
                                span.view-all-link(v-if="resourceResult.resources.length > 1")
                                    p(v-if="$store.state.queryGroupName == 'all' && !$store.getters.isAdmin") {{ resourceResult.total }} results
                                    LinkExtend(v-else :routeParams="filterFuzzyResourceGroupName(resourceResult.fuzzyResource)") {{ viewAllText(resourceResult.total) }}
                                        Tag(v-if="$store.state.queryGroupName !== 'all'") {{$store.state.queryGroupName}}
                            ListItem.launcher-list-item(v-for="item, index in resourceResult.resources" :key="index")
                                div.ivu-list-item-meta
                                    div.ivu-list-item-meta-content
                                        div.ivu-list-item-meta-title
                                            span {{ item._itemName }}
                                            span(style="margin-left: 15px;")
                                                Tag(v-for="tag in item.tags" :key="tag") {{ tag }}
                                        div.ivu-list-item-meta-description
                                            span {{ item.description }}
                                template(slot="action")
                                    li
                                        LinkExtend(:routeParams="item._routeParams") Manage
</template>
<script>
import { _debounce } from "@/libs/utils";
import { _searchResources } from "@/api/rest";
import vClickOutside from "v-click-outside";
import LinkExtend from "@/components/LinkExtend";

import Vue from "vue";
Vue.component("LinkExtend", LinkExtend);

export default {
    name: "ResourceLauncher",
    props: {},
    components: { LinkExtend },
    data() {
        return {
            searchPlaceHolder: `Search anything. (Eg. Domains, ${this.$i18n.t(
                "resourceType.AppProfile"
            )}, Wafs, descriptions or tags...)`,
            searchText: "",
            results: [],
            visible: false,
            spinShow: false
        };
    },
    mounted() {},
    directives: {
        clickOutside: vClickOutside.directive
    },
    watch: {
        $route(to, from) {
            this.visible = false;
        }
    },
    methods: {
        searchDebounce() {},
        handleInput(queryValue) {
            // console.log(queryValue);
            if (queryValue.length > 0) {
                this.visible = true;
                this.searchDebounce(queryValue);
            } else {
                this.results = [];
                this.visible = false;
            }
        },
        handleFocus() {
            if (this.searchText.length > 0) {
                this.searchDebounce(this.searchText);
                this.visible = true;
            }
        },
        onClickOutside(event) {
            // console.log("Clicked outside. Event: ", event);
            this.visible = false;
        },
        viewAllText(total) {
            if (this.$store.state.queryGroupName == "all") {
                return `view all ${total} results`;
            }
            return `view all ${total} results at `;
        },
        setFuzzyResourceGroupName(fuzzyResource) {
            return {
                ...fuzzyResource,
                query: {
                    ...fuzzyResource.query,
                    groupName: this.$store.state.queryGroupName,
                },
            }
        }
    },
    created() {
        var self = this;
        this.searchDebounce = _debounce(async function(queryValue) {
            try {
                // console.log(`Search for ${queryValue}`);
                self.spinShow = true;
                let result = await _searchResources(self.searchText, self.$store.state.queryGroupName);
                if (!result.data.success) throw new Error(result.data.message);
                self.results = result.data.data;
                self.spinShow = false;
            } catch (err) {
                console.log(err);
                self.spinShow = false;
            }
        });
    },
    computed: {
        noResult() {
            return this.searchText.length > 0 && this.results.every(e => e.resources.length == 0);
        }
    }
};
</script>

<style scoped>
.search-box >>> ::-webkit-input-placeholder {
    font-style: italic;
    color: rgb(165, 165, 165) !important;
}
.search-box >>> ::-moz-placeholder {
    font-style: italic;
    color: rgb(165, 165, 165) !important;
}
.search-box >>> :-moz-placeholder {
    font-style: italic;
    color: rgb(165, 165, 165) !important;
}
.search-box >>> :-ms-input-placeholder {
    font-style: italic;
    color: rgb(165, 165, 165) !important;
}

.search-box >>> .ivu-input.ivu-input-default {
    background: rgba(45, 45, 45, 0.8);
    color: #ffffff !important;
}

.view-all-link {
    position: absolute;
    right: 10px;
    top: 16px;
    font-size: 13px;
}

.launcher-list-item >>> ul {
    line-height: 0px;
}

.launcher-list >>> .ivu-list-header {
    padding-bottom: 0px;
}

.launcher >>> .ivu-dropdown {
    width: 100%;
}

.launcher >>> .ivu-select-dropdown {
    z-index: 1000;
}

.launcher >>> .ivu-card-body {
    width: 100%;
    height: 600px;
    overflow-y: scroll;
}

.launcher >>> .ivu-select-dropdown {
    width: 100vw;
    /*margin-left: calc(-50vw + 50%);*/
    margin-left: calc(-50vw);
    left: 0 !important;
    top: 60px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ResourceLauncherMob.vue